import { useTranslation } from 'react-i18next'
import { LogOut, RotateCcw, WifiOff } from 'lucide-react'
import { Button } from './ui/Button'
import { ErrorState } from './ui/ErrorState'

/**
 * #194 (D3) — le profil n'a pas pu être chargé (429, réseau, 5xx) malgré les
 * nouvelles tentatives. La session n'est PAS jetée : l'agent réessaie, ou
 * choisit lui-même de se déconnecter.
 */
export function ProfileErrorScreen({ onRetry, onLogout }: { onRetry: () => void; onLogout: () => void }) {
  const { t } = useTranslation('shell')
  return (
    <div className="min-h-screen bg-slate-900">
      <ErrorState
        icon={WifiOff}
        tone="danger"
        title={t('profileError.title')}
        description={t('profileError.description')}
        actions={
          <>
            <Button variant="secondary" icon={LogOut} onClick={onLogout}>
              {t('profileError.logout')}
            </Button>
            <Button variant="primary" icon={RotateCcw} onClick={onRetry}>
              {t('profileError.retry')}
            </Button>
          </>
        }
      />
    </div>
  )
}
